import { FlattenProducts, Products, } from './types';
import { ShopCartItem } from 'store/ducks/shopCart/types';

export const renderRows = (
    data: Array<FlattenProducts>,
    callback: (
        prevProduct: FlattenProducts | null,
        current: FlattenProducts,
        productsQuantity: number
    ) => {}
) => data.map((product, index, self) => {
    const prevProduct = index === 0 ? null : self[index - 1];
    const productsQuantity = product.products ? product.products.length + 1 : 1;

    return callback(prevProduct, product, productsQuantity);
});

export const flatProducts = (allProducts: Array<FlattenProducts>, product: ShopCartItem, index: number) => {
    const no = index + 1;
    const products = product.details?.products
        ? product.details.products.map((product: Products) => ({ ...product, no, }))
        : [];

    const { details, ...rest } = product;

    return [
        ...allProducts,
        { ...details, ...rest, no, },
        ...products,
    ];
};
